export const employeeRoles = ['administrator', 'animator', 'employee'];
export class Employee {
  constructor(id, firstName, lastName, professionalEmail, companyEmployeeId, eulaAccepted, receiveNewsletter, privacyPolicyAccepted, role, isFMDBeneficiary, user, partner, surveyAnswers, status, inscriptionLink, hasFirstName, hasLastName, hasProfessionalEmail, hasTransportHabits, departmentIsMissing, hasAtLeastOneCommutingTrip) {
    this.id = id;
    this.firstName = firstName;
    this.lastName = lastName;
    this.professionalEmail = professionalEmail;
    this.companyEmployeeId = companyEmployeeId;
    this.eulaAccepted = eulaAccepted;
    this.receiveNewsletter = receiveNewsletter;
    this.privacyPolicyAccepted = privacyPolicyAccepted;
    this.role = role;
    this.isFMDBeneficiary = isFMDBeneficiary;
    this.user = user;
    this.partner = partner;
    this.surveyAnswers = surveyAnswers;
    this.status = status;
    this.inscriptionLink = inscriptionLink;
    this.hasFirstName = hasFirstName;
    this.hasLastName = hasLastName;
    this.hasProfessionalEmail = hasProfessionalEmail;
    this.hasTransportHabits = hasTransportHabits;
    this.departmentIsMissing = departmentIsMissing;
    this.hasAtLeastOneCommutingTrip = hasAtLeastOneCommutingTrip;
  }
  get name() {
    return [this.firstName, this.lastName].filter(Boolean).join(' ');
  }
  get reversedName() {
    return [this.lastName, this.firstName].filter(Boolean).join(' ');
  }
  get isAdmin() {
    return this.role === 'administrator';
  }
  get isAnimator() {
    return this.role === 'animator';
  }
  get isCollaborator() {
    return this.role === 'employee';
  }
  get isAdminOrAnimator() {
    return ['administrator', 'animator'].includes(this.role);
  }
}